<template>
  <SmallSquare content='提货券可让消费者扫码查看活动信息，并到全部/指定门店进行奖品核' :padding=true></SmallSquare>
  <a-card :bordered="false">
    <div class="m-b-20 s_flex_bian_c">
      <a-button type="primary" v-has:pickUpCouponCreate="()=>{$router.push({path:'/assets/coupons/pickUpCoupon/create',query:{type:'add'}})}">
        <PlusOutlined />
        新增提货券
      </a-button>
    </div>
    <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keywords'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="id">卡券ID</a-select-option>
            <a-select-option value="name">名称</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="有效期" name='time'>
        <a-range-picker valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChangeCreate" />
      </a-form-item>

      <a-form-item label="状态" name='status' class="m-t-10">
        <a-select v-model:value="search.status" :style="{width:'140px',}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="0">未开始</a-select-option>
          <a-select-option :value="1">进行中</a-select-option>
          <a-select-option :value="2">已结束</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="是否启用" name='is_open' class="m-t-10">
        <a-select v-model:value="search.is_open" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item class="m-t-10">
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      <template v-slot:action="{ record }">
        <a-button v-has:pickUpCouponEdit="()=> {$router.push('/assets/coupons/pickUpCoupon/edit?type=edit&id='+record.id)}" class="m-r-10">编辑</a-button>
        <a-button v-has:pickUpCouponStatus='()=>invalid(record)' class="m-r-10" type="primary">{{record.is_open == 1 ? '禁用':'启用'}}</a-button>
        <a-button v-has:pickUpCouponDel='()=>del(record)' class="m-r-10"  danger v-if='record.is_open == 0'>删除</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs, createVNode, h } from "vue";
import {
  getPickUpCouponList,
  statePickUpCoupon,
  delPickUpCoupon,
} from "@/api/assets";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  key_type: "id",
  keyword: "",
  status: "",
  is_open: "",
  start_time: "",
  end_time: "",
  create_start_time: "",
  create_end_time: "",
};
export default {
  components: { PlusOutlined },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let list = ref([]);
    const state = reactive({
      showAdd: false,
      listLoading: false,
      time: [],
      total: 1,
    });
    let columns = [
      {
        title: "卡券ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "有效期",
        key: "valid_period_time",
        dataIndex: "valid_period_time",
        align: "center",
        customRender: ({ record }) => {
          return record.start_time + "-" + record.end_time;
        },
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "状态",
        dataIndex: "status_title",
        key: "status_title",
      },
      {
        title: "是否启用",
        dataIndex: "is_open_title",
        key: "is_open_title",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
        width:260
      },
    ];
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const onChangeCreate = (e) => {
      search.value.create_start_time = e[0];
      search.value.create_end_time = e[1];
    };
    const invalid = async (e) => {
      $Modal.confirm({
        centered: true,
        width: 500,
        title: "确定要使提货券" + (e.is_open ? "禁用" : "启用") + "吗？",
        icon: createVNode(ExclamationCircleOutlined),
        onOk: async () => {
          let res = await statePickUpCoupon({ id: e.id }).then(
            (res) => res.data
          );
          if (iscode(res, true)) {
            setTimeout(() => {
              initData(search.value);
            }, 1000);
          }
        },
      });
    };
    const del = (e) => {
      $Modal.confirm({
        centered: true,
        width: 500,
        title: "温馨提示",
        icon: createVNode(ExclamationCircleOutlined),
        content: h("div", {}, [
          h("p", "删除后该卡券将无法恢复，您确定要删除该卡券吗？"),
        ]),
        onOk: async () => {
          let res = await delPickUpCoupon({ id: e.id }).then((res) => res.data);
          if (iscode(res, true)) {
            setTimeout(() => {
              initData(search.value);
            }, 1000);
          }
        },
      });
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getPickUpCouponList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          console.log(res);
          list.value = res.data.data;
          state.total = res.data.total;
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    onMounted(() => {
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      invalid,
      onChange,
      onChangeCreate,
      del,
    };
  },
};
</script>